import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "d-flex" }
const _hoisted_2 = { class: "pr-4" }
const _hoisted_3 = {
  key: 0,
  class: "d-flex"
}
const _hoisted_4 = { class: "px-4" }
const _hoisted_5 = { class: "px-4" }
const _hoisted_6 = { class: "px-4" }
const _hoisted_7 = {
  key: 1,
  class: "d-flex"
}
const _hoisted_8 = { class: "px-4" }
const _hoisted_9 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_form = _resolveComponent("v-form")!

  return (_openBlock(), _createBlock(_component_v_form, {
    modelValue: _ctx.isFormValid,
    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.isFormValid) = $event))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _cache[6] || (_cache[6] = _createElementVNode("h5", null, "請求方法", -1)),
          _createVNode(_component_v_select, {
            modelValue: _ctx.inputBillingMethod,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.inputBillingMethod) = $event)),
            items: _ctx.billingMethodItems,
            variant: "outlined",
            density: "compact",
            "hide-details": ""
          }, null, 8, ["modelValue", "items"])
        ]),
        (_ctx.billingMethod == 'hourly')
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _cache[7] || (_cache[7] = _createElementVNode("h5", null, "課金時間", -1)),
                _createVNode(_component_v_text_field, {
                  modelValue: _ctx.inputHourly.billingMinute,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.inputHourly.billingMinute) = $event)),
                  rules: [_ctx.isSafeInteger, _ctx.isNaturalNumber],
                  type: "number",
                  variant: "outlined",
                  density: "compact",
                  "hide-details": "",
                  suffix: "分毎"
                }, null, 8, ["modelValue", "rules"])
              ]),
              _createElementVNode("div", _hoisted_5, [
                _cache[8] || (_cache[8] = _createElementVNode("h5", null, "金額", -1)),
                _createVNode(_component_v_text_field, {
                  modelValue: _ctx.inputHourly.billingAmount,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.inputHourly.billingAmount) = $event)),
                  rules: [_ctx.isNaturalNumber],
                  type: "number",
                  variant: "outlined",
                  density: "compact",
                  "hide-details": "",
                  suffix: "円"
                }, null, 8, ["modelValue", "rules"])
              ]),
              _createElementVNode("div", _hoisted_6, [
                _cache[9] || (_cache[9] = _createElementVNode("h5", null, "上限", -1)),
                _createVNode(_component_v_text_field, {
                  modelValue: _ctx.inputHourly.billingUpperLimitAmount,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.inputHourly.billingUpperLimitAmount) = $event)),
                  rules: [_ctx.isNaturalNumber],
                  type: "number",
                  variant: "outlined",
                  density: "compact",
                  "hide-details": "",
                  suffix: "円"
                }, null, 8, ["modelValue", "rules"])
              ])
            ]))
          : (_ctx.billingMethod == 'monthly')
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _cache[10] || (_cache[10] = _createElementVNode("h5", null, "金額", -1)),
                  _createVNode(_component_v_text_field, {
                    modelValue: _ctx.inputMonthly.billingAmount,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.inputMonthly.billingAmount) = $event)),
                    rules: [_ctx.isNotMinus],
                    type: "number",
                    variant: "outlined",
                    density: "compact",
                    "hide-details": "",
                    suffix: "円"
                  }, null, 8, ["modelValue", "rules"])
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_9))
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}